/**
 * B.S.C. Laboratories — 21+ age gate
 *
 * Behavior:
 * - Blocks all storefront content until the visitor confirms a DOB + checkbox showing 21+.
 * - Stores ONLY a boolean "confirmed" flag in sessionStorage (clears when the browser tab/session ends).
 *   The actual date of birth is never persisted anywhere (no cookie, no localStorage, no network call).
 * - Underage / declined visitors are sent to the configured safe redirect URL, no site content is shown.
 * - Step two (optional marketing email signup) only appears after step one succeeds, and is always skippable.
 */
(function () {
  var STORAGE_KEY = 'bscAgeConfirmed';
  var root = document.getElementById('bsc-age-gate');
  if (!root) return;

  var alreadyConfirmed = false;
  try {
    alreadyConfirmed = sessionStorage.getItem(STORAGE_KEY) === 'true';
  } catch (e) {
    /* sessionStorage unavailable (private mode etc.) — fall through and show the gate every load */
  }

  if (alreadyConfirmed) {
    root.hidden = true;
    document.documentElement.classList.remove('bsc-gate-locked');
    return;
  }

  document.documentElement.classList.add('bsc-gate-locked');

  var stepAge = root.querySelector('[data-bsc-step="age"]');
  var stepEmail = root.querySelector('[data-bsc-step="email"]');
  var form = root.querySelector('[data-bsc-age-form]');
  var monthInput = root.querySelector('[name="bsc-dob-month"]');
  var dayInput = root.querySelector('[name="bsc-dob-day"]');
  var yearInput = root.querySelector('[name="bsc-dob-year"]');
  var confirmCheckbox = root.querySelector('[name="bsc-age-confirm"]');
  var errorEl = root.querySelector('[data-bsc-age-error]');
  var exitBtn = root.querySelector('[data-bsc-exit]');
  var redirectUrl = root.getAttribute('data-redirect-url') || '/pages/age-restriction-policy';
  var skipEmailBtn = stepEmail ? stepEmail.querySelector('[data-bsc-skip-email]') : null;
  var emailForm = stepEmail ? stepEmail.querySelector('form') : null;

  function isTouchedInvalid(input) {
    return !input.value;
  }

  function calcAge(month, day, year) {
    var today = new Date();
    var dob = new Date(year, month - 1, day);
    if (dob.getMonth() !== month - 1) return -1; // invalid date, e.g. Feb 30
    var age = today.getFullYear() - dob.getFullYear();
    var m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
    return age;
  }

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.setAttribute('data-visible', 'true');
  }

  function clearError() {
    if (!errorEl) return;
    errorEl.removeAttribute('data-visible');
  }

  function exitSite() {
    window.location.href = redirectUrl;
  }

  function confirmSuccess() {
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      /* ignore */
    }
    if (stepEmail) {
      stepAge.hidden = true;
      stepEmail.hidden = false;
      trapFocus(stepEmail);
    } else {
      closeGate();
    }
  }

  function closeGate() {
    root.hidden = true;
    document.documentElement.classList.remove('bsc-gate-locked');
    document.removeEventListener('keydown', onKeydown, true);
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var month = parseInt(monthInput.value, 10);
      var day = parseInt(dayInput.value, 10);
      var year = parseInt(yearInput.value, 10);

      if (
        isTouchedInvalid(monthInput) || isTouchedInvalid(dayInput) || isTouchedInvalid(yearInput) ||
        month < 1 || month > 12 || day < 1 || day > 31 || year < 1900 || year > new Date().getFullYear()
      ) {
        showError('Please enter a complete, valid date of birth.');
        return;
      }

      if (!confirmCheckbox.checked) {
        showError('Please check the box confirming you are 21 or older.');
        return;
      }

      var age = calcAge(month, day, year);
      if (age < 21) {
        exitSite();
        return;
      }

      confirmSuccess();
    });
  }

  if (exitBtn) {
    exitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      exitSite();
    });
  }

  if (skipEmailBtn) {
    skipEmailBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeGate();
    });
  }

  if (emailForm) {
    emailForm.addEventListener('submit', function () {
      window.setTimeout(closeGate, 50);
    });
  }

  function getFocusable(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
  }

  function trapFocus(container) {
    var focusable = getFocusable(container);
    if (focusable.length) focusable[0].focus();
  }

  function onKeydown(e) {
    if (e.key !== 'Tab') return;
    var activeStep = stepAge && !stepAge.hidden ? stepAge : stepEmail;
    if (!activeStep) return;
    var focusable = getFocusable(activeStep);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('keydown', onKeydown, true);
  trapFocus(stepAge);
})();
